import { BatteryFull, Car02, Sun } from "@untitledui/icons";
import { Leaf01 } from "../../assets/leaf-01";
import {
  PlaybookContentIntegrationType,
  PlaybookContentPlanType,
} from "../../state/api.types";

export const PLAN_TYPES: Record<
  PlaybookContentPlanType,
  {
    label: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    tooltip: string;
  }
> = {
  [PlaybookContentPlanType.Simple]: {
    label: "Simple",
    icon: Leaf01,
    tooltip: "Simple plans",
  },
  [PlaybookContentPlanType.Solar]: {
    label: "Solar",
    icon: Sun,
    tooltip: "Solar buyback plans",
  },
  [PlaybookContentPlanType.Battery]: {
    label: "Battery",
    icon: BatteryFull,
    tooltip: "Plans with battery programs",
  },
  [PlaybookContentPlanType.Ev]: {
    label: "EV",
    icon: Car02,
    tooltip: "Plans with EV charging programs",
  },
};

export const INTEGRATIONS: Record<
  PlaybookContentIntegrationType,
  {
    label: string;
    badgeLabel?: string;
    tooltip?: string;
  }
> = {
  [PlaybookContentIntegrationType.All]: {
    label: "All",
    badgeLabel: "All integrations",
  },
  [PlaybookContentIntegrationType.NativeApi]: {
    label: "API",
    tooltip: "Native experiences using our back-end API",
  },
  [PlaybookContentIntegrationType.EmbeddedUi]: {
    label: "Embedded",
    tooltip: "Experiences using our embedded flows",
  },
  [PlaybookContentIntegrationType.NoCodeWebApp]: {
    label: "No-code",
    tooltip: "Our ready out-of-the-box no-code web app",
  },
};
